export default "__VITE_ASSET__9e20616f__"